import { useLocation } from 'react-router-dom';
import { HEADCOUNT_PATH, TAB_SLUGS } from '../HeadcountRoutes';

/** The landing tab, keeping any query string. */
export const useIndexRedirectTarget = (): string => {
  const { search } = useLocation();
  return `${HEADCOUNT_PATH}/${TAB_SLUGS.overview}${search}`;
};
